import { gql } from '@apollo/client';

export const UPDATE_PERMISSION_PACKAGE = gql`
  mutation UpdatePermissionPackage($input: PermissionPackageApiRequestInput!) {
    updatePermissionPackage(input: $input) {
      success
      message
      messageCode
      data {
        id
        name
        description
        resources
      }
    }
  }
`;

export interface PermissionPackageApiRequestInput {
  id?: number | null;
  name: string;
  description?: string | null;
  resourceCodes?: string[];
}
